//
// MoodandFood.js
// - ------------------------------------------------------
// - Functions to support the Healify Wellness challenge page
// - ------------------------------------------------------
//
import * as imageURL from "../img/illustrations/flowers/*.svg";
import { checkUrlParam, isSignedIn } from "./auth.js";

// global vars to this scope
var moodAndFoodTimer = null; // create a timer reference

// getUrlVars
// Get variables from a Url formatted like https://page.html?var1=foo&var2=bar
function getUrlVars() {
  var vars = {};
  var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
      vars[key] = value;
  });
  return vars;
}

// moodandfood Page
// Configure the mood and food page based on the signed in state
function moodAndFoodPage() {
  if (isSignedIn()) { // is the user signed in?
    var $jqe_action_button = $('#primary_action_button');
    $jqe_action_button.addClass('check-in-button');
    $jqe_action_button.find('span').text('Check-in now');
    setCheckInBehavior();
    $jqe_action_button.attr('href', '/activity.html?category=challenge');
    $('#join-message').text('Get ready,')
    $('.marketing-promo').hide(); // hide the marketing sections when user is signed in
    // $('#pills-activity-tab')[0].click(); // select the activity tab
  }
  // else {
  //   $('#pills-about-tab')[0].click(); // select the about tab
  // }
}

function getActivities(name) {
   try {
      fetch('https://api.airtable.com/v0/appKMHuPgfJLToeN1/checkins?api_key=keyCv10aSA2Vxn4Ch')
        .then(res => res.json())
        .then(res => {
          if (!res || !res.records || !res.records.length){
            throwError();
            return;
          }
          const lastIndex = res.records.length - 1;
          const sortedRecords = res.records.sort(function(a,b){
            return new Date(b.createdTime) - new Date(a.createdTime);
          });

          $.each(sortedRecords, function(index, value) {
            $("#latest-activity").append(
              "<div style='display: flex; flex-direction: row; align-items: center; justify-content: center; height: 144px; margin: 10px; width: 48%; background-color: #f1f2fb; border: #dddddd solid 2px;'><div style='padding: 20px;'><img style='width: 80px; vertical-align: top;' src='"
              + imageURL[value.fields["Flower"]] + "'"
              + 'alt="custom"/></div><div style="display: flex; flex-direction: column; width: 64%; text-align: left"><p style="padding: 0; margin: 0;">'
              + value.fields["Name"] + ' ' + moment(value.fields["Created"]).fromNow() + '</p><h5>'
              + value.fields["Description"]
              + '</h5></div><div style="display: flex; flex-direction: column; text-align: left"><h5 style="margin: 0"> +'
              + value.fields["Points"]
              + '</h5><span> Points </span></div></div>' );
          });
          for (let i = 0; i < res.records.length; i++){
            $('#latest-activity').append(

            )
          }
        })
      } catch (error) {
        console.log(error);
        throwError();
      } finally {

      }
}

export function getMoodAndFoodEventData(){
  const data = {}; // instantiate object
  data.startTime = new Date("30 August 2021 10:00:00 GMT-07:00"); // Event starts Aug 28 10:00am PDT
  data.endTime = new Date("04 September 2021 10:00:00 GMT-07:00"); // Event end Sep 4 10:00am PDT
  return data;
}

// set up the checkin behavior so it can throw an alert during pre-registration, and be wired up after
function setCheckInBehavior(){
  if (isPreRegistration()) {
    $('.check-in-button').click(function(e){
      e.preventDefault();
      alert('"Check-in" will become active once the challenge has begun. Read your welcome email for more instructions.');
    });
  }
}

export function isPreRegistration(){
  if (getTimeLeft(getMoodAndFoodEventData().startTime) > 0) {
    return true;
  } else {
    return false;
  }
}

function isChallengeRunning(){
  if (getTimeLeft(getMoodAndFoodEventData().startTime) === 0 && getTimeLeft(getMoodAndFoodEventData().endTime) > 0) {
    return true;
  } else {
    return false;
  }
}

function isChallengeOver(){
  if (getTimeLeft(getMoodAndFoodEventData().endTime) === 0) {
    return true;
  } else {
    return false;
  }
}

// getTimeLeft - gets time remaining from a given time until now, in seconds. returns 0 if no time is remaining
function getTimeLeft(time){
  var targetTime = (Date.parse(time) / 1000);

  var now = new Date();
  now = (Date.parse(now) / 1000);

  var timeLeft = targetTime - now;
  if (timeLeft < 0) timeLeft = 0; // set timeLeft to 0 if we've got past the startTime

  return timeLeft;
}

function initializeTimer(){
  moodAndFoodTimer = setInterval(function() { startTimer(); }, 1000); // declared globally so we can stop it if needed
}

function stopTimer(){
  clearInterval(moodAndFoodTimer);
}

function startTimer() {
  var timeLeft = getTimeLeft(getMoodAndFoodEventData().startTime);
  if (timeLeft === 0) stopTimer(); // stop the Timer if we have no time left
  // console.log(timeLeft);

  var days = Math.floor(timeLeft / 86400);
  var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
  var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
  var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));

  if (hours < "10") { hours = hours; }
  if (minutes < "10") { minutes = minutes; }
  if (seconds < "10") { seconds = seconds; }

  $("#days").html(days + "<span> days</span>");
  $("#hours").html(hours + "<span> hours</span>");
  $("#minutes").html(minutes + "<span> minutes</span>");
  $("#seconds").html(seconds + "<span> seconds</span>");
}

$(document).ready(function(){
  checkUrlParam(); // set up account
  moodAndFoodPage(); // set up mood and food page
  initializeTimer(); // initialize the countdown timer
  getActivities();

});
